var _path, _path2, _path3, _path4, _g, _path5, _path6, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNmibleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 12,
    viewBox: "0 0 51 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.87852 7.63507V11.5519C7.87852 11.7344 7.76103 11.8506 7.57671 11.8506H6.001C5.79992 11.8506 5.68262 11.7344 5.68262 11.5519V7.9339C5.68262 6.77176 4.99522 6.02496 3.98962 6.02496C2.8833 6.02496 2.19589 6.85472 2.19589 7.86717V11.5519C2.19589 11.7344 2.0786 11.8506 1.89408 11.8506H0.318567C0.117298 11.8506 0 11.7344 0 11.5519V4.51478C0 4.3319 0.117298 4.21595 0.318567 4.21595H1.27389C1.45841 4.21595 1.5757 4.3319 1.59246 4.51478L1.65949 5.51063C2.11211 4.71369 3.08438 4.06644 4.49251 4.06644C6.55435 4.06644 7.87852 5.46067 7.87852 7.63507Z",
    fill: "#0A3E45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8478 7.61829V11.5519C22.8478 11.7344 22.7305 11.8506 22.5461 11.8506H20.9704C20.7692 11.8506 20.6519 11.7344 20.6519 11.5519V7.93372C20.6519 6.78854 20.0484 6.02496 19.1097 6.02496C18.1039 6.02496 17.4502 6.80495 17.4502 7.90054V11.5519C17.4502 11.7344 17.3495 11.8506 17.1484 11.8506H15.5727C15.3716 11.8506 15.2541 11.7344 15.2541 11.5519V7.93372C15.2541 6.78854 14.6339 6.02496 13.7289 6.02496C12.6728 6.02496 12.0526 6.85472 12.0526 7.86717V11.5519C12.0526 11.7344 11.9353 11.8506 11.7508 11.8506H10.1751C9.97404 11.8506 9.85655 11.7344 9.85655 11.5519V4.51478C9.85655 4.3319 9.97404 4.21595 10.1751 4.21595H11.1306C11.315 4.21595 11.4323 4.3319 11.449 4.51478L11.516 5.56022C11.9184 4.73046 12.9074 4.06644 14.0975 4.06644C15.3211 4.06644 16.2767 4.59773 16.8466 5.4109C17.316 4.66391 18.2044 4.06644 19.361 4.06644C21.3894 4.06644 22.8478 5.49385 22.8478 7.61829Z",
    fill: "#0A3E45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8423 11.5519V4.51475C24.8423 4.33205 24.9598 4.21591 25.1442 4.21591H26.7199C26.9209 4.21591 27.0384 4.33205 27.0384 4.51475V11.5519C27.0384 11.7344 26.9209 11.8507 26.7199 11.8507H25.1442C24.9431 11.8507 24.8423 11.7344 24.8423 11.5519ZM24.4737 1.52718C24.4737 0.713829 25.0939 0.166128 25.8984 0.149536C26.7199 0.149536 27.3568 0.713829 27.3568 1.52718C27.3568 2.34034 26.7199 2.90463 25.8984 2.90463C25.0939 2.90463 24.4737 2.34034 24.4737 1.52718Z",
    fill: "#0A3E45"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_59_16345",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 0,
    width: 9,
    height: 12
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1169 0H37.381V12H29.1169V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_59_16345)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1683 8.03321C35.1683 6.90443 34.3133 6.0415 33.1904 6.0415C31.9834 6.0415 31.2122 6.90443 31.2122 8.03321C31.2122 9.19498 31.9834 10.0249 33.1904 10.0249C34.3133 10.0249 35.1683 9.17857 35.1683 8.03321ZM37.381 8.03321C37.381 10.2906 35.7384 12 33.6094 12C32.4528 12 31.581 11.5185 30.9776 10.8549L30.9273 11.5519C30.9106 11.751 30.7933 11.8507 30.6088 11.8507H29.4354C29.2341 11.8507 29.1169 11.7344 29.1169 11.5519V0.298831C29.1169 0.116326 29.2341 0 29.4354 0H30.9944C31.1954 0 31.3129 0.116326 31.3129 0.298831V5.06205C31.8659 4.48135 32.654 4.06656 33.6764 4.06656C35.8054 4.06656 37.381 5.77603 37.381 8.03321Z",
    fill: "#0A3E45"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0573 11.5519V0.298831C39.0573 0.116325 39.1747 0 39.3758 0H40.9517C41.1359 0 41.2533 0.116325 41.2533 0.298831V11.5519C41.2533 11.7344 41.1359 11.8507 40.9517 11.8507H39.3758C39.1747 11.8507 39.0573 11.7344 39.0573 11.5519Z",
    fill: "#0A3E45"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_59_16345",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 4,
    width: 9,
    height: 8
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9294 4.0665H50.791V12H42.9294V4.0665Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_59_16345)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1251 7.23657H48.7124L48.6958 7.18661C48.5616 6.37344 47.9079 5.79275 47.0361 5.79275C46.0639 5.79275 45.3599 6.30726 45.1251 7.23657ZM50.7744 8.33197C50.7577 8.51448 50.6569 8.6308 50.4724 8.6308H45.1251C45.3767 9.52711 46.2316 10.1744 47.4048 10.1744C48.2765 10.1744 48.8299 9.85875 49.1987 9.59347C49.3663 9.47715 49.5171 9.49374 49.6178 9.67643L50.2045 10.7053C50.305 10.8714 50.2883 11.0209 50.1373 11.1368C49.6178 11.5354 48.6791 12.0002 47.1704 12.0002C44.723 12.0002 42.9294 10.2739 42.9294 8.03314C42.9294 5.80934 44.5887 4.0665 46.9524 4.0665C49.2825 4.0665 50.791 5.75938 50.791 8.04973C50.791 8.14947 50.791 8.23261 50.7744 8.33197Z",
    fill: "#0A3E45"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNmibleLogo);
export default __webpack_public_path__ + "static/media/nmible_logo.8d07f20184a227ee65ce066f44bf647d.svg";
export { ForwardRef as ReactComponent };